import { render, staticRenderFns } from "./special-service.vue?vue&type=template&id=028db3ea&scoped=true&"
import script from "./special-service.vue?vue&type=script&lang=js&"
export * from "./special-service.vue?vue&type=script&lang=js&"
import style0 from "./special-service.vue?vue&type=style&index=0&id=028db3ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028db3ea",
  null
  
)

export default component.exports